import React from "react";

const Projects = () => {
  return (
    <div
      name="projects"
      className="sm:mb-20 w-full h-full bg-[#0a192f] text-white"
    >
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div>
          <p className="text-4xl font-bold inline border-b-4 border-[#38A5FF]">
            Projects
          </p>
          <p className="pt-4">
            Here are some of the projects that I've done during school, at my
            internship, and on my own to hone my skills
          </p>
        </div>

        <div className="w-full mt-8">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
            <div className="flex flex-col">
              <p className="mb-2 font-semibold text-lg">
                <a
                  href="https://fantasy-basketball-companion.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#38A5FF] hover:underline inline-flex items-center gap-1"
                >
                  Fantasy Basketball Companion
                  <svg xmlns="http://www.w3.org/2000/svg" className="inline w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M14 3h7m0 0v7m0-7L10 14M5 5H3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-2" />
                  </svg>
                </a>{" "}
                -{" "}
                <span className="text-sm text-[#38A5FF]">Personal Project</span>
              </p>
              <ol className="text-gray-300 mb-4 text-sm">
                <li className="py-1">
                  Built a full-stack web application for fantasy basketball
                  enthusiasts featuring a schedule analyzer, AI-powered coach,
                  and roster management in a unified platform.
                </li>
                <li className="py-1">
                  Integrated a Gemini-powered chatbot that provides personalized
                  trade, waiver wire, and lineup recommendations by incorporating
                  the user's saved roster data.
                </li>
              </ol>
              <div className="flex flex-wrap space-x-2">
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Next.js
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  TypeScript
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Supabase
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Google Gemini
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Tailwind CSS
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  shadcn/ui
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  NBA Stats API
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full mt-8">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
            <div className="flex flex-col">
              <p className="mb-2 font-semibold text-lg">
                <a
                  href="https://huggingface.co/spaces/mithun14/prop-model"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#38A5FF] hover:underline inline-flex items-center gap-1"
                >
                  NBA Predictive Analytics Platform
                  <svg xmlns="http://www.w3.org/2000/svg" className="inline w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M14 3h7m0 0v7m0-7L10 14M5 5H3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-2" />
                  </svg>
                </a>{" "}
                -{" "}
                <span className="text-sm text-[#38A5FF]">Personal Project</span>
              </p>
              <ol className="text-gray-300 mb-4 text-sm">
                <li className="py-1">
                  Developed a machine learning pipeline to predict NBA player
                  performance metrics (points, rebounds, assists) using advanced
                  regression and ensemble models (Linear Regression, Random
                  Forest, XGBoost, LightGBM).
                </li>
                <li className="py-1">
                  Automated data collection using Selenium to scrape usage rates
                  and defense metrics from dynamic sports websites, reducing
                  manual preprocessing time
                </li>
              </ol>
              <div className="flex flex-wrap space-x-2">
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Python
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Selenium
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  scikit-learn
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  pandas
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  NumPy
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  NBA_API
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Flask
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Gradio
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  pytest
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full mt-8">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
            <div className="flex flex-col">
              <p className="mb-2 font-semibold text-lg">
                VetConnect -{" "}
                <span className="text-sm text-[#38A5FF]">
                  Toronto Metropolitan University
                </span>
              </p>
              <ol className="text-gray-300 mb-4 text-sm">
                <li className="py-1">
                  Collaborated with four developers to develop, design,
                  troubleshoot, and document a secure and reliable all-in-one
                  patient management system to streamline the communication
                  between pet owners and veterinarians.
                </li>
              </ol>
              <div className="flex flex-wrap space-x-2">
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  TypeScript
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  HTML
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  CSS
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  React
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Supabase
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  PostgreSQL
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full mt-8">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
            <div className="flex flex-col">
              <p className="mb-2 font-semibold text-lg">
                Olympic Medal Predictor -{" "}
                <span className="text-sm text-[#38A5FF]">Personal Project</span>
              </p>
              <ol className="text-gray-300 mb-4 text-sm">
                <li className="py-1">
                  Developed and trained a linear regression model to predict the
                  amount of medals a country will win based on past results.
                </li>
              </ol>
              <div className="flex flex-wrap space-x-2">
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Python
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Jupyter Notebook
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Pandas
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  seaborn
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  scikit-learn
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full mt-8">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
            <div className="flex flex-col">
              <p className="mb-2 font-semibold text-lg">
                Smart Recruiter -{" "}
                <span className="text-sm text-[#38A5FF]">
                  OPS Phenomenal Hackathon
                </span>
              </p>
              <ol className="text-gray-300 mb-4 text-sm">
                <li className="py-1">
                  Developed an all-in-one recruitment platform securing 2nd
                  place in the OPS Phenomenal Hackathon by leveraging
                  Microsoft's tools to significantly reduce time spent during
                  the hiring process
                </li>
                <li className="py-1">
                  Utilized Microsoft's 'Category Classification Model' to detect
                  the likelihood of an application being composed by AI
                </li>
              </ol>
              <div className="flex flex-wrap space-x-2">
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Microsoft Power Apps
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  JavaScript
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  REST APIs
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Machine Learning Models
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full mt-8">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
            <div className="flex flex-col">
              <p className="mb-2 font-semibold text-lg">
                Portfolio -{" "}
                <span className="text-sm text-[#38A5FF]">Personal Project</span>
              </p>
              <ol className="text-gray-300 mb-4 text-sm">
                <li className="py-1">
                  Developed a website to showcase more about me and hone my
                  skills in React and Tailwind CSS
                </li>
              </ol>
              <div className="flex flex-wrap space-x-2">
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  HTML
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  JavaScript
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Tailwind CSS
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  React
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full mt-8">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
            <div className="flex flex-col">
              <p className="mb-2 font-semibold text-lg">
                Soccer League Database System -{" "}
                <span className="text-sm text-[#38A5FF]">
                  Toronto Metropolitan University
                </span>
              </p>
              <ol className="text-gray-300 mb-4 text-sm">
                <li className="py-1">
                  Built a relational database management system using SQL and
                  Oracle DB to track all information needed for a soccer league
                </li>
                <li className="py-1">
                  Conducted comprehensive testing protocols to verify data
                  integrity, consistency, and reliability
                </li>
              </ol>
              <div className="flex flex-wrap space-x-2">
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  SQL
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Oracle DB
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  GitHub
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full mt-8">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
            <div className="flex flex-col">
              <p className="mb-2 font-semibold text-lg">
                Java Stock Market System -{" "}
                <span className="text-sm text-[#38A5FF]">
                  Toronto Metropolitan University
                </span>
              </p>
              <ol className="text-gray-300 mb-4 text-sm">
                <li className="py-1">
                  Collaborated with 5 developers to develop, design,
                  troubleshoot, and document an object-oriented system that
                  simulates the purchasing and selling of stocks using real-time
                  data
                </li>
                <li className="py-1">
                  Engineered comprehensive UML models to optimize system
                  architecture for objects
                </li>
                <li className="py-1">
                  Automated unit testing by leverging Java's JUnit testing
                  framework
                </li>
              </ol>
              <div className="flex flex-wrap space-x-2">
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Java
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  JUnit
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Alpha Vantage API
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  GitHub
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full mt-8">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
            <div className="flex flex-col">
              <p className="mb-2 font-semibold text-lg">
                NBA Stats -{" "}
                <span className="text-sm text-[#38A5FF]">Personal Project</span>
              </p>
              <ol className="text-gray-300 mb-4 text-sm">
                <li className="py-1">
                  Created a Python application to retrieve, clean, and evaluate
                  data from NBA players to learn more about data analysis in
                  Python
                </li>
                <li className="py-1">
                  Constructed interactive shot charts to visually depict
                  players' shooting performance throughout a given season
                </li>
              </ol>
              <div className="flex flex-wrap space-x-2">
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Python
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  NBA_API
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Beautiful Soup
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Requests
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Pandas
                </span>
                <span className="mt-1 rounded bg-[#2f343d53] px-2 py-1 text-sm font-medium text-[#38A5FF]">
                  Matplotlib
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
